import React, { FC, createContext } from 'react';

const PageContext = createContext({
	scroll: () => {},
});

interface PageProps {
	children: JSX.Element | JSX.Element[];
	scroll: () => void;
}

const PageContextProvider: FC<PageProps> = ({ children, scroll }) => {
	const value = {
		scroll: scroll,
	};

	return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};

export { PageContext, PageContextProvider };
